/**
 * An `Element` with the `:with-feature` attribute will be removed if the
 * named feature is disabled on this portal.
 *
 * @example
 * ```html
 * <div :with-feature="livecam">
 *   <!-- The div is removed if the livecam feature is disabled -->
 * </div>
 * ```
 *
 * @module :with-feature
 * @author Jacob Viertel <jv@onscreen.net>
 * @since 3.83.0
 * @see [hasFeature](../service/env.js)
 */

import {defineCompileAttribute} from '@acng/frontend-stargazer';
import {removeNode} from '@acng/frontend-bounty';

import {hasFeature} from '../service/env.js';

const MODULE = 'core/attribute/with-feature';
const VERBOSE = false;
DEBUG: if (VERBOSE) console.warn('Import verbose', MODULE);

defineCompileAttribute(':with-feature', (element, featureName) => {
  DEBUG: if (VERBOSE || element.hasAttribute('debug')) console.debug(MODULE, {element});

  if (!hasFeature(featureName)) {
    DEBUG: if (VERBOSE || element.hasAttribute('debug')) console.info(MODULE, 'remove', {element});

    removeNode(element);
  }
});
